import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import className from "classnames";
import PopoverBox from "../PopoverBox/PopoverBox";

var PopoverContent = /*#__PURE__*/function (_React$Component) {
  _inherits(PopoverContent, _React$Component);

  var _super = _createSuper(PopoverContent);

  function PopoverContent() {
    var _this;

    _classCallCheck(this, PopoverContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(PopoverContent.displayName));

    _defineProperty(_assertThisInitialized(_this), "handleUpdate", function () {
      _this.props.scheduleUpdate();

      if (_this.props.handleFocus) {
        _this.props.handleFocus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (_this.props.isActive && _this.props.isActive !== prevProps.isActive) {
        _this.handleUpdate();
      } else if (_this.props.isActive && _this.props.handleForceUpdateContent && _this.props.handleForceUpdateContent()) {
        _this.handleUpdate();
      }
    });

    return _this;
  }

  _createClass(PopoverContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          boxClass = _this$props.boxClass,
          boxStyles = _this$props.boxStyles,
          children = _this$props.children,
          contentPlacement = _this$props.contentPlacement,
          contentRef = _this$props.contentRef,
          contentStyle = _this$props.contentStyle,
          id = _this$props.id,
          isActive = _this$props.isActive,
          role = _this$props.role,
          handleBlur = _this$props.handleBlur;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: this.getClassName({
          modifiers: className({
            active: isActive
          })
        }),
        "data-placement": contentPlacement,
        ref: contentRef,
        role: role,
        style: contentStyle,
        onBlur: handleBlur
      }, /*#__PURE__*/React.createElement(PopoverBox, {
        boxClass: boxClass,
        boxStyles: boxStyles
      }, children));
    }
  }]);

  return PopoverContent;
}(React.Component);

_defineProperty(PopoverContent, "displayName", "PopoverContent");

export default PopoverContent;